var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FetchErrorTransition',{attrs:{"isFetching":_vm.isFetching,"error":_vm.fetchError}},[_c('BillingSettings',{attrs:{"userIsAdvanced":_vm.userIsAdvanced},on:{"save":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }